import React, { useEffect, useState } from 'react';
import { supabase } from '../App';

const TABLE = 'announcements';
const EMPTY = { guid: '', announcement: '', valid_from: '', valid_until: '' };
const toInputValue = (value) => value ? new Date(value).toISOString().slice(0, 16) : '';

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState('Loading announcements...');

  const load = async () => {
    if (!supabase) return setStatus('Supabase is not configured');
    const { data, error } = await supabase.from(TABLE).select('*').order('valid_from', { ascending: false });
    if (error) setStatus(`Load failed: ${error.message}`);
    else { setItems(data || []); setStatus(`${data?.length || 0} announcements`); }
  };
  useEffect(() => { load(); }, []);
  const setValue = (name, value) => setForm((current) => ({ ...current, [name]: value }));
  const edit = (item) => setForm({ guid: item.guid, announcement: item.announcement, valid_from: toInputValue(item.valid_from), valid_until: toInputValue(item.valid_until) });
  const save = async (event) => {
    event.preventDefault();
    if (!form.announcement.trim() || !form.valid_from || !form.valid_until) return setStatus('Complete all announcement fields.');
    const row = { guid: form.guid || crypto.randomUUID(), announcement: form.announcement.trim(), valid_from: new Date(form.valid_from).toISOString(), valid_until: new Date(form.valid_until).toISOString(), updated_at: new Date().toISOString() };
    const { data, error } = await supabase.from(TABLE).upsert(row).select().single();
    if (error) setStatus(`Save failed: ${error.message}`);
    else { setItems((current) => [...current.filter((item) => item.guid !== data.guid), data].sort((a, b) => b.valid_from.localeCompare(a.valid_from))); setForm(EMPTY); setStatus('Announcement saved'); }
  };
  const remove = async (guid) => {
    if (!window.confirm('Delete this announcement?')) return;
    const { error } = await supabase.from(TABLE).delete().eq('guid', guid);
    if (error) setStatus(`Delete failed: ${error.message}`);
    else { setItems((current) => current.filter((item) => item.guid !== guid)); setStatus('Announcement deleted'); }
  };

  return <section className="management-panel">
    <div className="live-header"><div><span className="eyebrow">DEMAND MODEL INPUT</span><h2>Announcements</h2></div><span className="dashboard-toast">{status}</span></div>
    <form className="management-form" onSubmit={save}>
      <label className="wide-field">Announcement<textarea value={form.announcement} onChange={(event) => setValue('announcement', event.target.value)} rows="3" /></label>
      <label>Valid from<input type="datetime-local" value={form.valid_from} onChange={(event) => setValue('valid_from', event.target.value)} /></label>
      <label>Valid until<input type="datetime-local" value={form.valid_until} onChange={(event) => setValue('valid_until', event.target.value)} /></label>
      <div className="modal-actions"><button type="button" className="button muted" onClick={() => setForm(EMPTY)}>Clear</button><button className="button primary" type="submit">Save announcement</button></div>
    </form>
    <div className="table-panel management-table"><div className="table-scroll"><table><thead><tr><th>GUID</th><th>Announcement</th><th>Valid from</th><th>Valid until</th><th>Actions</th></tr></thead><tbody>{items.map((item) => <tr key={item.guid}><td className="mono">{item.guid}</td><td>{item.announcement}</td><td>{new Date(item.valid_from).toLocaleString('en-GB')}</td><td>{new Date(item.valid_until).toLocaleString('en-GB')}</td><td><button className="button muted" onClick={() => edit(item)}>Edit</button> <button className="delete" onClick={() => remove(item.guid)}>Delete</button></td></tr>)}</tbody></table></div></div>
    {!items.length && <div className="empty-state">No announcements added.</div>}
  </section>;
}
